import ROUTES from '../routes';
import Balance from '../hoc/balance/balance';
import Sheet from '../hoc/balance/sheet';
import FRS from '../hoc/balance/frs';

const BalanceRoutes = {
  path: ROUTES.REPORTS_BALANCE,
  element: <Balance />,
  children: [
    {
      path: ROUTES.REPORTS_BALANCE_SHEET,
      element: <Sheet />,
    },
    {
      path: ROUTES.REPORTS_BALANCE_FRS,
      element: <FRS />,
    },
  ],
};

export default BalanceRoutes;
